export default __webpack_public_path__ + "static/media/logo.b10ba153.svg";